import { Button } from "@mui/material";
import { IconCopy } from "@tabler/icons-react";
import { useCustomSnackbar } from "hooks/customSnackbar";

// "User ID: XXX" rendered as a text button that copies the id to the clipboard
// with a success toast -- easier than selecting the raw text by hand. Inherits
// the surrounding color/size so it still reads as the subtle footer label.
const CopyUserId = ({ id }: { id?: string | null }) => {
  const { enqueueSnackbar } = useCustomSnackbar();
  if (!id) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(id);
      enqueueSnackbar("User ID copied to clipboard!", { variant: "success" });
    } catch {
      enqueueSnackbar("Couldn't copy User ID.", { variant: "error" });
    }
  };

  return (
    <Button
      onClick={copy}
      variant="text"
      startIcon={<IconCopy size={14} />}
      sx={{
        color: "inherit",
        textTransform: "none",
        fontWeight: "inherit",
        fontSize: "inherit",
        p: 0,
        minWidth: 0,
        lineHeight: "inherit",
      }}
    >
      User ID: {id}
    </Button>
  );
};

export default CopyUserId;
